import React from 'react';

import SuccessRedirector from 'components/SuccessRedirector';

export default function ChangePasswordSuccess() {
  return <SuccessRedirector description="Your password has been successfully updated." />;
}
